import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, Column } from '@carbon/react';
import { ArrowRight, Home } from '@carbon/icons-react';
import { useTheme } from '../context/ThemeContext';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();

  const isDark = theme === 'dark';
  const bgPrimary = isDark ? '#161616' : '#ffffff';
  const textPrimary = isDark ? '#f4f4f4' : '#161616';
  const textSecondary = isDark ? '#c6c6c6' : '#525252';

  return (
    <section
      style={{
        backgroundColor: bgPrimary,
        minHeight: 'calc(100vh - 48px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 0',
      }}
    >
      <Grid>
        <Column lg={{ span: 8, offset: 4 }} md={{ span: 6, offset: 1 }} sm={4}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ marginBottom: '32px' }}>
              <span style={{ fontSize: '3rem', fontWeight: 700, color: '#0f62fe', lineHeight: 1.2, display: 'block' }}>
                Oops, you hit a snag!
              </span>
              <svg width="200" height="140" viewBox="0 0 200 140" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ margin: '16px auto', display: 'block' }}>
                {/* Cat body */}
                <ellipse cx="100" cy="100" rx="50" ry="30" fill={isDark ? '#393939' : '#e0e0e0'} />
                {/* Cat head */}
                <circle cx="100" cy="60" r="28" fill={isDark ? '#525252' : '#c6c6c6'} />
                {/* Left ear */}
                <polygon points="78,40 68,15 88,35" fill={isDark ? '#525252' : '#c6c6c6'} />
                <polygon points="80,38 72,20 87,35" fill={isDark ? '#393939' : '#e0e0e0'} />
                {/* Right ear */}
                <polygon points="122,40 132,15 112,35" fill={isDark ? '#525252' : '#c6c6c6'} />
                <polygon points="120,38 128,20 113,35" fill={isDark ? '#393939' : '#e0e0e0'} />
                {/* Eyes */}
                <circle cx="88" cy="55" r="5" fill={isDark ? '#f4f4f4' : '#161616'} />
                <circle cx="112" cy="55" r="5" fill={isDark ? '#f4f4f4' : '#161616'} />
                <circle cx="89.5" cy="53.5" r="1.5" fill={isDark ? '#161616' : '#ffffff'} />
                <circle cx="113.5" cy="53.5" r="1.5" fill={isDark ? '#161616' : '#ffffff'} />
                {/* Nose */}
                <polygon points="100,63 96,68 104,68" fill="#ff69b4" />
                {/* Mouth */}
                <path d="M96 70 Q100 76 104 70" stroke={isDark ? '#f4f4f4' : '#161616'} strokeWidth="1.5" fill="none" />
                {/* Whiskers */}
                <line x1="60" y1="60" x2="85" y2="63" stroke={isDark ? '#c6c6c6' : '#525252'} strokeWidth="1" />
                <line x1="60" y1="68" x2="85" y2="67" stroke={isDark ? '#c6c6c6' : '#525252'} strokeWidth="1" />
                <line x1="115" y1="63" x2="140" y2="60" stroke={isDark ? '#c6c6c6' : '#525252'} strokeWidth="1" />
                <line x1="115" y1="67" x2="140" y2="68" stroke={isDark ? '#c6c6c6' : '#525252'} strokeWidth="1" />
                {/* Tail */}
                <path d="M150 95 Q170 70 160 50" stroke={isDark ? '#525252' : '#c6c6c6'} strokeWidth="6" fill="none" strokeLinecap="round" />
              </svg>
            </div>
            <h1 style={{ color: textPrimary, fontSize: '2.5rem', fontWeight: 600, marginBottom: '16px' }}>
              Page Not Found
            </h1>
            <p style={{ color: textSecondary, fontSize: '1.125rem', lineHeight: 1.7, marginBottom: '32px', maxWidth: '480px', margin: '0 auto 32px' }}>
              The page you're looking for doesn't exist or has been moved.
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button kind="primary" size="lg" onClick={() => navigate('/')} renderIcon={Home}>
                Go Home
              </Button>
              <Button kind="secondary" size="lg" onClick={() => navigate(-1)} renderIcon={ArrowRight}>
                Go Back
              </Button>
            </div>
          </div>
        </Column>
      </Grid>
    </section>
  );
};

export default NotFoundPage;
